import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';
import { Toaster } from 'sonner';
import { Suspense } from 'react';
import { router } from './routes/routes';
import { ThemeProvider } from './components';
import { StateServiceApi } from './services/State.service.api';
import { VatServiceApi } from './services/Vat.service.api';
import { useIsAuthenticated } from './hooks/useIsAuthenticated';
import { LogViewerProvider } from './modules/Log/context/LogViewerProvider';

const queryClient = new QueryClient();

function App() {
	const isAuthenticated = useIsAuthenticated();

	return (
		<ThemeProvider defaultTheme="dark" storageKey="vite-ui-theme">
			<QueryClientProvider client={queryClient}>
				<LogViewerProvider>
					<Suspense fallback={null}>
						<Toaster richColors />
						<RouterProvider
							router={router}
							future={{
								v7_startTransition: true,
							}}
						/>
						{isAuthenticated && (
							<>
								<StateServiceApi />
								<VatServiceApi />
							</>
						)}
					</Suspense>
				</LogViewerProvider>
			</QueryClientProvider>
		</ThemeProvider>
	);
}

export default App;
